import React, { Component } from "react";

import edit from "../images/edit.svg";
import Delete from "../images/deletewhite.svg";
import disable from "../images/disable.svg";
import enable from "../images/enable.svg";
import copy from "../images/copy.svg";
import warning from "../images/warning.png";
import CustomButton from "./CustomButton";
import OptionItem from "./OptionItem";
import plus from "../images/plus.svg";
import noimage from "../images/noimage.png";
import Tick from "../images/tick.svg";
import Cancel from "../images/cancel.svg";
import { Form, Modal } from "react-bootstrap";
import addimage from "../images/addimage.svg";
import axios from "axios";
import { toast } from "react-toastify";
import { NumericFormat } from "react-number-format";
import { word } from "../words.js";
import Tooltip from "@mui/material/Tooltip";
import Dropzone from "react-dropzone";
import {
  BaseUrl,
  Authorization,
  BaseUrlAssets,
  LogoutFunction,
} from "../static.js";

export default class FoodItem extends Component {
  constructor(props) {
    super(props);

    let edit = false;
    if (this.props.createNew) {
      console.log("1");
      edit = true;
    }

    if (!edit && this.props.editId === this.props.id) {
      console.log("2");
      edit = true;
    }

    this.state = {
      ActionsOpen: false,
      editMode: edit,
      nameValue: "",
      desValue: "",
      priceValue: this.props.price,
      ModalShow: false,
      imageUrl:
        this.props.img2 !== undefined &&
        this.props.img2 !== null &&
        this.props.img2 !== ""
          ? BaseUrlAssets + this.props.img2
          : null,
      imageFileName:
        this.props.img1 !== undefined &&
        this.props.img1 !== null &&
        this.props.img1 !== ""
          ? this.props.img1
          : null,
      imageFileName2:
        this.props.img2 !== undefined &&
        this.props.img2 !== null &&
        this.props.img2 !== ""
          ? this.props.img2
          : null,
      imageFileName3:
        this.props.img3 !== undefined &&
        this.props.img3 !== null &&
        this.props.img3 !== ""
          ? this.props.img3
          : null,
      uploadButtonDisable: false,
      deleteLoading: false,
      title: "",
      name: "",
      description: "",
      priceUnit: "",
      desWarning: false,
    };

    this.ActionMainButton = React.createRef();
    this.textHandleChange = this.textHandleChange.bind(this);
    this.saveEditClick = this.saveEditClick.bind(this);
    this.inputFile = React.createRef();
    this.inputName = React.createRef();
    this.uploadImage = this.uploadImage.bind(this);
    this.onUploadImageClick = this.onUploadImageClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener("click", (e) => {
      try {
        if (
          this.ActionMainButton !== undefined &&
          this.ActionMainButton !== null &&
          !this.ActionMainButton.current.contains(e.target)
        ) {
          this.setState({ ActionsOpen: false });
        }
      } catch (error) {}
    });

    if (this.props.createNew) {
      this.inputName.current.focus();
    } else {
      this.updateTitle();

      if (this.state.editMode) {
        this.inputName.current.focus();
      }
    }
  }

  componentDidUpdate(prvProps) {
    if (this.props.img2 !== prvProps.img2) {
      this.setState({
        imageUrl:
          this.props.img2 !== undefined &&
          this.props.img2 !== null &&
          this.props.img2 !== ""
            ? BaseUrlAssets + this.props.img2
            : null,
        imageFileName2:
          this.props.img2 !== undefined &&
          this.props.img2 !== null &&
          this.props.img2 !== ""
            ? this.props.img2
            : null,
      });
    }

    if (
      prvProps.selectedLangId !== this.props.selectedLangId ||
      prvProps.nameObj !== this.props.nameObj
    ) {
      this.updateTitle();
    }

    if (
      prvProps.editId !== this.props.editId &&
      this.props.editId !== this.props.id &&
      this.state.editMode
    ) {
      this.setState({ editMode: false });
    }
  }

  updateTitle() {
    let title = "";
    let name = "";
    this.props.nameObj.forEach((element) => {
      if (
        element.languageId === this.props.selectedLangId &&
        (element.name !== "" ||
          element.name !== null ||
          element.name !== undefined)
      ) {
        title = element.name;
        name = element.name;
      }
    });

    let descr = "";
    let found = false;
    this.props.descrObj.forEach((element) => {
      if (element.languageId === this.props.selectedLangId) {
        descr = element.descr;
      }

      if (
        element.descr !== undefined &&
        element.descr !== null &&
        element.descr !== ""
      )
        found = true;
    });

    if (found && descr === "") {
      this.setState({ desWarning: true }, () => {
        // ReactTooltip.rebuild();
      });
    } else {
      this.setState({ desWarning: false });
    }

    this.setState({ description: descr, desValue: descr });

    if (title === "") {
      this.props.nameObj.forEach((element) => {
        if (
          element.languageId === this.props.defaultLangId &&
          (element.name !== "" ||
            element.name !== null ||
            element.name !== undefined)
        ) {
          title = element.name;
        }
      });
    }

    if (title === "") {
      this.props.nameObj.forEach((element) => {
        if (
          (element.name !== "" ||
            element.name !== null ||
            element.name !== undefined) &&
          title === ""
        ) {
          title = element.name;
        }
      });
    }

    this.setState({ title: title, name: name, nameValue: name });
  }

  copyQRClick() {}

  copyURLClick() {}

  onActionsMainButtonClick() {
    this.setState({ ActionsOpen: !this.state.ActionsOpen });
  }

  onEdit() {
    this.setState(
      {
        editMode: true,
        nameValue: this.state.name,
        desValue: this.state.description,
        priceValue: this.props.price,
        ActionsOpen: false,
      },
      () => {
        this.inputName.current.focus();
        this.props.onEditMode(this.props.id);
      }
    );
  }

  onDelete() {
    this.setState({ ModalShow: true });
  }

  itemDeleteConfirm() {
    let data = {
      languageId: this.props.selectedLangId,
      businessId: Number(this.props.businessId),
      businessCode: this.props.businessCode,
      foodId: Number(this.props.id),
      categoryId: Number(this.props.catId),
      priority: this.props.priority,
    };

    data = Object.assign(data, Authorization());

    console.log("data", data);

    this.setState({ deleteLoading: true });

    fetch(BaseUrl + "deleteProduct", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.props.onDeleteFood(result.result);
        } else {
          toast.error("حذف با مشکل مواجه شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
        this.setState({ deleteLoading: false }, () => {
          this.hideModal();
        });
      })
      .catch((err) => {
        this.setState({ deleteLoading: false });
        console.log(err);
      });
  }

  onDisable() {
    let data = {
      languageId: this.props.selectedLangId,
      name: this.state.name,
      descr: this.state.description,
      id: this.props.id,
      foodPicS1: this.state.imageFileName,
      foodPicS2: this.state.imageFileName2,
      foodPicS3: this.state.imageFileName3,
      categoryId: this.props.catId,
      businessId: this.props.businessId,
      businessCode: this.props.businessCode,
      price: this.props.price,
      isEnable: !this.props.isEnable,
      priority: this.props.priority,
    };

    data = Object.assign(data, Authorization());

    console.log(data);

    fetch(BaseUrl + "updateProduct", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.props.onUpdateFood(result.result);
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ newCat: false });
      });
  }

  cancelEditClick() {
    // if (this.props.createNew) {
    //   this.props.onCancel();
    // } else {
    //   this.setState({ editMode: false });
    // }

    this.props.onCancel();
    this.setState({ editMode: false });
  }

  saveEditClick() {
    if (
      this.state.nameValue === undefined ||
      this.state.nameValue === null ||
      this.state.nameValue === ""
    ) {
      toast.error("نام نمی‌تواند خالی باشد", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 6000,
        toastClassName: "toast",
      });
      return;
    }

    if (
      this.state.priceValue === undefined ||
      this.state.priceValue === null ||
      this.state.priceValue === ""
    ) {
      toast.error("قیمت نمی‌تواند خالی باشد", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 6000,
        toastClassName: "toast",
      });
      return;
    }

    // if (isNaN(Number(this.state.priceValue.replace(',','')))){
    //     toast.error('قیمت درست نیست', {
    //         position: toast.POSITION.BOTTOM_RIGHT,
    //         hideProgressBar:true,
    //         autoClose: 6000,
    //         toastClassName: 'toast'
    //     });
    //     return;
    // }

    let price = this.state.priceValue
      .toString()
      .replace(/,/g, "")
      .replace(/ /g, "")
      .replace(/ریال/g, "");

    if (this.props.createNew) {
      let data = {
        languageId: this.props.selectedLangId,
        categoryId: this.props.catId,
        name: this.state.nameValue,
        descr: this.state.desValue,
        foodPicS1: this.state.imageFileName,
        foodPicS2: this.state.imageFileName2,
        foodPicS3: this.state.imageFileName3,
        price: Number(price),
        priority: this.props.foodsLength,
        businessId: this.props.businessId,
        businessCode: this.props.businessCode,
        isEnable: 1,
      };
      this.props.onSubmit("createProduct", data);
    } else {
      let data = {
        languageId: this.props.selectedLangId,
        id: this.props.id,
        categoryId: this.props.catId,
        name: this.state.nameValue,
        descr: this.state.desValue,
        foodPicS1: this.state.imageFileName,
        foodPicS2: this.state.imageFileName2,
        foodPicS3: this.state.imageFileName3,
        price: Number(price),
        priority: this.props.priority,
        businessId: this.props.businessId,
        businessCode: this.props.businessCode,
        isEnable: this.props.isEnable,
      };
      this.props.onSubmit("updateProduct", data);
      this.setState({ editMode: false });
    }
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  optionsClick() {}

  onUploadImageClick(event) {
    if (
      event.target.files[0] !== undefined &&
      (event.target.files[0].type === "image/jpg" ||
        event.target.files[0].type === "image/png" ||
        event.target.files[0].type === "image/jpeg")
    ) {
      this.uploadImage(event.target.files[0]);
    }
  }

  uploadImage(file) {
    // if (event.target.files[0]!==undefined && (event.target.files[0].type === "image/jpg" || event.target.files[0].type ==="image/png" || event.target.files[0].type ==="image/jpeg")) {
    const data = new FormData();
    data.append("file", file);
    data.append("type", "food");
    this.setState({ uploadButtonDisable: true });
    axios
      .post(BaseUrl + "uploadfile", data)
      .then((res) => {
        // console.log(res);
        if (res.data.status === 200) {
          this.setState({
            imageUrl: BaseUrlAssets + res.data.data.fileName1,
            imageFileName: res.data.data.fileName1,
            imageFileName2: res.data.data.fileName2,
            imageFileName3: res.data.data.fileName3,
          });
          toast.success("بارگذاری عکس با موفقیت انجام شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
          this.setState({ uploadButtonDisable: false });
        } else {
          this.setState({ uploadButtonDisable: false });
          toast.error(res.data.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        this.setState({ uploadButtonDisable: false });
        toast.error(err.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 6000,
          toastClassName: "toast",
        });
        console.log(err);
      });
    // }
  }

  changeImageClick() {
    this.inputFile.current.click();
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  editOptionsClick() {
    this.setState({ ModalShow: true });
  }

  addOptionClick() {}

  closeClick() {}

  onDuplicate() {
    let data = {
      languageId: this.props.selectedLangId,
      name: this.state.name,
      descr: this.state.description,
      id: this.props.id,
      foodPicS1: this.state.imageFileName,
      foodPicS2: this.state.imageFileName2,
      foodPicS3: this.state.imageFileName3,
      categoryId: this.props.catId,
      businessId: this.props.businessId,
      businessCode: this.props.businessCode,
      price: this.props.price,
      isEnable: this.props.isEnable,
      priority: this.props.priority,
    };

    data = Object.assign(data, Authorization());

    console.log(data);

    // this.setState({duplicateLoading:true})

    fetch(BaseUrl + "copyProduct", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState({ ActionsOpen: false });
          this.props.onDuplicateFood(result.result);
        } else {
          toast.error("کپی با مشکل مواجه شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
          // this.setState({duplicateLoading:false})
        }
      })
      .catch((err) => {
        this.setState({ duplicateLoading: false });
        console.log(err);
      });
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.saveEditClick();
    }
  }

  acceptedFile(files) {
    console.log(files);

    this.uploadImage(files[0]);
  }

  rejectedFiles(files) {
    switch (files[0].errors[0].code) {
      case "file-invalid-type": {
        toast.error("نوع فایل باید عکس باشد", {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 6000,
          toastClassName: "toast",
        });
        break;
      }
      case "too-many-files": {
        toast.error("فقط یک عکس برای محصول انتخاب کنید", {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 6000,
          toastClassName: "toast",
        });
        break;
      }
      default: {
        toast.error("مشکل در بارگذاری فایل", {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 6000,
          toastClassName: "toast",
        });
        break;
      }
    }
    console.log(files);
  }

  render() {
    if (!this.state.editMode) {
      return (
        <div className="fiObjectContainer" style={{ position: "relative" }}>
          <div
            className="fiObjectItem"
            style={{
              opacity: !this.props.isEnable ? "0.6" : "1",
            }}
          >
            <div className="fiObjectImage">
              <img
                src={
                  this.state.imageUrl !== "" &&
                  this.state.imageUrl !== null &&
                  this.state.imageUrl !== undefined
                    ? this.state.imageUrl
                    : noimage
                }
                alt=""
                style={{
                  objectFit:
                    this.state.imageUrl !== "" &&
                    this.state.imageUrl !== null &&
                    this.state.imageUrl !== undefined
                      ? "cover"
                      : "contain",
                  width:
                    this.state.imageUrl !== "" &&
                    this.state.imageUrl !== null &&
                    this.state.imageUrl !== undefined
                      ? "100%"
                      : "80%",
                  height:
                    this.state.imageUrl !== "" &&
                    this.state.imageUrl !== null &&
                    this.state.imageUrl !== undefined
                      ? "100%"
                      : "80%",
                }}
              />
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: "transparent",
                  position: "absolute",
                  left: "0",
                  top: "0",
                }}
              />
            </div>
            <div
              className={this.props.rtlClass}
              style={{
                flex: "1",
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                className="fiObjectTitle"
                style={{
                  color:
                    this.state.name === "" ? "var(--gray3)" : "var(--black1)",
                }}
              >
                {this.state.title}
              </div>
              {this.state.name === "" && (
                <Tooltip title="عنوان محصول را در زبان مورد نظر تکمیل کنید">
                  <img
                    src={warning}
                    alt=""
                    style={{
                      margin: "0px 10px",
                      width: "20px",
                      height: "20px",
                      objectFit: "contain",
                    }}
                    // data-tip="عنوان محصول را در زبان مورد نظر تکمیل کنید"
                    // data-delay-show="300"
                    // data-delay-hide="200"
                  />
                </Tooltip>
              )}
            </div>

            <div
              style={{
                minHeight: "1px",
                width: "100%",
                backgroundColor: "var(--gray4)",
              }}
            />

            <div
              style={{
                flex: "1.5",
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                padding: "5px 0px",
              }}
            >
              {this.state.description !== "" && (
                <div
                  className={
                    this.props.currentLang === "fa"
                      ? "fiObjectDes rtlStyle"
                      : "fiObjectDes ltrStyle"
                  }
                >
                  {this.state.description}
                </div>
              )}
              {this.state.description === "" && (
                <div
                  className="fiObjectDes"
                  style={{ fontStyle: "italic", color: "var(--gray3)" }}
                >
                  بدون توضیح
                </div>
              )}
              {this.state.desWarning && (
                <Tooltip title="توضیح محصول را در زبان مورد نظر تکمیل کنید">
                  <img
                    src={warning}
                    alt=""
                    style={{
                      margin: "0px 10px",
                      width: "15px",
                      height: "15px",
                      objectFit: "contain",
                    }}
                    // data-tip="توضیح محصول را در زبان مورد نظر تکمیل کنید"
                    // data-delay-show="300"
                    // data-delay-hide="200"
                  />
                </Tooltip>
              )}
            </div>

            <div
              style={{
                minHeight: "1px",
                width: "100%",
                backgroundColor: "var(--gray4)",
              }}
            />

            <div
              style={{
                flex: "0.8",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="fiObjectPrice">
                <NumericFormat
                  allowNegative={true}
                  value={this.props.price}
                  displayType={"text"}
                  thousandSeparator={true}
                />
                &nbsp;{this.props.unit}
              </div>
            </div>
            <div
              style={{
                minHeight: "1px",
                width: "100%",
                backgroundColor: "var(--gray4)",
              }}
            />
          </div>
          <div
            className="qrObjectActionMainButton"
            ref={this.ActionMainButton}
            onClick={this.onActionsMainButtonClick.bind(this)}
          >
            <img
              src={edit}
              alt=""
              style={{ height: "65%", width: "65%", objectFit: "contain" }}
            />
          </div>
          <div
            className="qrObjectActionsContainer"
            style={{
              visibility: this.state.ActionsOpen ? "visible" : "hidden",
            }}
          >
            <div
              className="qrObjectActionButton"
              onClick={this.onEdit.bind(this)}
            >
              <img
                src={edit}
                alt=""
                style={{
                  width: "12px",
                  objectFit: "contain",
                  marginLeft: "6px",
                }}
              />
              <div>ویرایش</div>
            </div>

            <div
              className="qrObjectActionButton"
              onClick={this.onDuplicate.bind(this)}
            >
              <img
                src={copy}
                alt=""
                style={{
                  width: "12px",
                  objectFit: "contain",
                  marginLeft: "6px",
                }}
              />
              <div>کپی</div>
            </div>

            <div
              className="qrObjectActionButton"
              onClick={this.onDisable.bind(this)}
            >
              <img
                src={this.props.isEnable === 1 ? disable : enable}
                alt=""
                style={{
                  width: "12px",
                  objectFit: "contain",
                  marginLeft: "6px",
                }}
              />
              <div>{this.props.isEnable === 1 ? "غیرفعال" : "فعال"}</div>
            </div>

            <div
              className="qrObjectActionButton"
              onClick={this.onDelete.bind(this)}
            >
              <img
                src={Delete}
                alt=""
                style={{
                  width: "12px",
                  objectFit: "contain",
                  marginLeft: "6px",
                }}
              />
              <div>حذف</div>
            </div>
          </div>
          {this.props.OPWarning && (
            <div
              className="qrObjectActionMainButton"
              style={{
                left: "unset",
                right: "5px",
                backgroundColor: "unset",
              }}
            >
              <Tooltip title="این محصول در هیچ یک از گام‌های روال سفارش به کار نرفته است">
                <img
                  src={warning}
                  alt=""
                  style={{
                    height: "20px",
                    width: "20px",
                    objectFit: "contain",
                  }}
                  // data-tip="این محصول در هیچ یک از گام‌های روال سفارش به کار نرفته است"
                  // data-delay-show="300"
                  // data-delay-hide="200"
                />
              </Tooltip>
            </div>
          )}
          <Modal
            show={this.state.ModalShow}
            animation={false}
            onHide={this.hideModal.bind(this)}
            centered
          >
            <div className="dialogBox">
              اطمینان از حذف "{this.state.title}"؟
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="خیر"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    img={Cancel}
                    onClick={this.hideModal.bind(this)}
                  />
                </div>
                <div style={{ minWidth: "5px" }} />
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="بله"
                    loading={this.state.deleteLoading}
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    img={Tick}
                    onClick={this.itemDeleteConfirm.bind(this)}
                  />
                </div>
              </div>
            </div>
          </Modal>
        </div>
      );
    } else {
      return (
        <div className="fiObjectContainer">
          <div className="fiObjectItem">
            <div className="fiObjectImage">
              {(this.state.imageUrl === "" ||
                this.state.imageUrl === null ||
                this.state.imageUrl === undefined) && (
                <img
                  src={noimage}
                  alt=""
                  style={{ objectFit: "contain", width: "80%", height: "80%" }}
                />
              )}
              {this.state.imageUrl !== "" &&
                this.state.imageUrl !== null &&
                this.state.imageUrl !== undefined && (
                  <img
                    src={this.state.imageUrl}
                    alt=""
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                )}
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: "transparent",
                  position: "absolute",
                  left: "0",
                  top: "0",
                }}
              />
            </div>

            <div
              style={{
                position: "absolute",
                height: "40%",
                width: "100%",
                top: "0",
                left: "0",
              }}
            >
              <Dropzone
                accept="image/*"
                multiple={false}
                onDropAccepted={this.acceptedFile.bind(this)}
                onDropRejected={this.rejectedFiles.bind(this)}
              >
                {({ getRootProps, getInputProps, isDragActive }) => (
                  <div {...getRootProps({ className: "dropzoneee" })}>
                    <input {...getInputProps()} />
                    {isDragActive ? (
                      <div className="dropZoneContainer">
                        <img
                          src={addimage}
                          alt=""
                          style={{
                            width: "40px",
                            height: "40px",
                            objectFit: "contain",
                            marginBottom: "5px",
                          }}
                        />
                        عکس را اینجا رها کنید
                      </div>
                    ) : null}
                  </div>
                )}
              </Dropzone>
              <div
                className="changeHeaderButtonContainer"
                style={{ marginRight: "5px", marginTop: "5px" }}
              >
                <CustomButton
                  title=""
                  loading={this.state.uploadButtonDisable}
                  loadingWidth="12px"
                  loadingHeight="12px"
                  fontFamily="SFUIDisplayLight"
                  fontSize="12px"
                  imgWidth={25}
                  imgHeight={25}
                  flexDirection="row-reverse"
                  img={addimage}
                  onClick={this.changeImageClick.bind(this)}
                />
              </div>
            </div>

            <input
              type="file"
              ref={this.inputFile}
              onChange={this.onUploadImageClick}
              accept="image/png,.jpg"
              style={{ display: "none" }}
              disabled={this.state.uploadButtonDisable}
            />

            <Form.Control
              className={"inputStyleForm fiEditTextFont" + this.props.rtlClass}
              // placeholder="عنوان"
              placeholder={word[this.props.currentLang]["title"]}
              type="text"
              name="nameValue"
              onChange={this.textHandleChange}
              value={this.state.nameValue}
              disabled={this.state.buttonDisabled}
              ref={this.inputName}
              onKeyPress={this.handleKeyPress.bind(this)}
            />
            <div
              style={{
                minHeight: "1px",
                width: "100%",
                backgroundColor: "var(--gray4)",
              }}
            />
            <Form.Control
              as="textarea"
              className={"inputStyleForm fiEditTextFont" + this.props.rtlClass}
              // placeholder="توضیحات"
              placeholder={word[this.props.currentLang]["description"]}
              style={{ minHeight: "60px" }}
              type="text"
              name="desValue"
              onChange={this.textHandleChange}
              value={this.state.desValue}
              disabled={this.state.buttonDisabled}
              onKeyPress={this.handleKeyPress.bind(this)}
            />
            <div
              style={{
                minHeight: "1px",
                width: "100%",
                backgroundColor: "var(--gray4)",
              }}
            />
            <NumericFormat
              className={
                "inputStyleForm fiEditTextFont form-control" +
                this.props.rtlClass
              }
              style={{ direction: "ltr" }}
              // placeholder="قیمت"
              placeholder={word[this.props.currentLang]["price"]}
              type="text"
              name="priceValue"
              onChange={this.textHandleChange}
              value={this.state.priceValue}
              disabled={this.state.buttonDisabled}
              onKeyPress={this.handleKeyPress.bind(this)}
              allowNegative={true}
              displayType={"input"}
              thousandSeparator={true}
            />
            {/* <NumericFormat placeholder="قیمت" className="inputStyleForm fiEditTextFont form-control" allowNegative={true} disabled={this.state.buttonDisabled} value={this.state.priceValue} displayType={'input'} thousandSeparator={true} /> */}
            {/* <div style={{minHeight:'1px',width:'100%',backgroundColor:'var(--gray4)'}}/> */}
            {/* <div style={{width:'100%',marginTop:'5px'}}><CustomButton title="Edit Options" minHeight="30px" img={null} onClick={this.editOptionsClick.bind(this)} /></div> */}

            <div className="qrObjectActionsContainer" style={{ top: "5px" }}>
              <div
                className="qrObjectActionButton"
                onClick={this.cancelEditClick.bind(this)}
              >
                <img
                  src={Cancel}
                  alt=""
                  style={{
                    width: "12px",
                    objectFit: "contain",
                    marginLeft: "6px",
                  }}
                />
                <div>انصراف</div>
              </div>
              <div
                className="qrObjectActionButton"
                style={{ backgroundColor: "var(--brown1)" }}
                onClick={this.saveEditClick}
              >
                <img
                  src={Tick}
                  alt=""
                  style={{
                    width: "12px",
                    objectFit: "contain",
                    marginLeft: "6px",
                  }}
                />
                <div>ذخیره</div>
              </div>
            </div>

            <Modal
              show={this.state.ModalShow}
              animation={false}
              onHide={this.hideModal.bind(this)}
              centered
            >
              <div className="optionsContainer">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <div className="fiObjectTitle">Options</div>
                  <div className="optionsListContainer">
                    <OptionItem />
                    {/* <OptionItem />
                                        <OptionItem />
                                        <OptionItem />
                                        <OptionItem />
                                        <OptionItem /> */}
                  </div>
                  <div style={{ width: "100%", marginTop: "5px" }}>
                    <CustomButton
                      title=""
                      imgHeight={25}
                      imgWidth={25}
                      minHeight="30px"
                      img={plus}
                      onClick={this.addOptionClick.bind(this)}
                    />
                  </div>
                </div>

                <div style={{ width: "100%", marginTop: "5px" }}>
                  <CustomButton
                    title="Close"
                    backColor="var(--black1)"
                    img={null}
                    onClick={this.closeClick.bind(this)}
                  />
                </div>
              </div>
            </Modal>
          </div>
        </div>
      );
    }
  }
}
